import React from 'react';
import _ from 'lodash';

const FormikTextareaGroup = ({
    formik,
    label = '',
    required = false,
    name,
    ...props
}) => {
    return (
        <div>
            <label className="block text-sm font-medium mb-1 text-slate-200" htmlFor={name}>
                {label} {required && <span className="text-rose-500">*</span>}
            </label>
            <textarea
                value={_.at(formik.values, name)[0]}
                onChange={formik.handleChange}
                name={name}
                onBlur={formik.handleBlur}
                className="w-full form-input border-0 text-slate-200"
                rows={5}
                cols={5}
                style={{
                    backgroundColor : '#141414'
                }}
                {...props}
            />
            {formik.errors[name] && formik.touched[name] ? (
                <p className="text-xs text-red-500">{formik.errors[name]}</p>
            ) : null}
        </div>
    );
};

export default FormikTextareaGroup;
